export default __webpack_public_path__ + "static/media/IMG_1625.6aa03df2.jpg";